function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, React.createElement("rect", {
  x: 592.255,
  y: -182,
  width: 878.454,
  height: 1136.51,
  rx: 50,
  transform: "rotate(30 592.255 -182)",
  fill: "url(#paint0_linear)"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M414.752 1027.85L67.3014 827.247C43.3867 813.44 35.1929 782.86 49 758.946L99.8634 670.848H910.567V1023.58L908.1 1027.85H414.752Z",
  fill: "#C4C4C4"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M414.752 1027.85L67.3014 827.247C43.3867 813.44 35.1929 782.86 49 758.946L99.8634 670.848H910.567V1023.58L908.1 1027.85H414.752Z",
  fill: "url(#paint1_linear)"
});
var _ref5 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M512.5 454L516.5 472.5H541.5L566 451.5H598.5L624 445L641.5 472.5H670L670.2 472H782.5L760.5 440L769.5 417.5L772 396.5L769.5 388L762.993 389.495L726 360.5L716 365.5L704 379L662 423.5L658 417L606 423.5L598.5 420L569.5 432.5L572.5 399.5L559.5 410L535.5 445V423.5L512.5 454ZM408.5 390L418 435L447 452L472.5 453L463 439.5L445.5 433.5L428.5 423L408.5 390ZM265 396.5L310 420L320 407.5L363.5 397H378L398 402L412 407.5L408 389.5L396 396.5L377 382.5H355L320 407.5L265 396.5ZM252 471.814L266.691 451.455V431.097L252 413C266.314 417.901 292.17 433.618 304.348 458.242C311.367 472.434 309.2 472.227 305.926 471.914H305.926C305.417 471.865 304.881 471.814 304.348 471.814H252ZM377.955 456.078L370.015 472H429L415.388 456.078L396.104 446.98L353 414L360.94 441.294L377.955 456.078ZM828.5 377.5L831.5 387V397L824 401.5L818.5 408.5L816 419.5L802.5 426.5V435.5L809.5 442L824 446L818.5 435.5V426.5H836.5L852.5 435.5L856 446L846.5 458L839.5 469L836.5 472.5H933L903.5 433L891 423V412.5L875.5 403L869.5 402.5L837.5 377.5H828.5Z",
  fill: "black",
  fillOpacity: 0.5
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.25
}, React.createElement("path", {
  d: "M485.5 455.5L477 464.5L467 450.5L450 444.5L433 434L412 400.5L400 407.5L381 393.5H359L324 418.5L269 407.5L232 444.5L208 483.5H937L908 444.5L895 434V423.5L879.5 414H873.5L841.5 388.5H833L827.5 383.5L817 379.5L813 383.5L794.5 388.5L768 400.5L730.5 371.5H722.5L715.5 369L646 418.5L639.5 410.5L635.5 414L611.5 423.5L604.5 418.5L593.5 414L584 407.5L577.5 410.5L569.5 407.5L485.5 455.5Z",
  fill: "#7C7C94"
}), React.createElement("path", {
  d: "M270.691 462.455L256 482.814H308.348C312.303 482.814 316.459 485.642 308.348 469.242C296.17 444.618 270.314 428.901 256 424L270.691 442.097V462.455Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M314 431L269 407.5L324 418.5L314 431Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M381.955 467.078L374.015 483H433L419.388 467.078L400.104 457.98L357 425L364.94 452.294L381.955 467.078Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M422 446L412.5 401L432.5 434L449.5 444.5L467 450.5L476.5 464L451 463L422 446Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M516.5 465L520.5 483.5H545.5L570 462.5H602.5L628 456L645.5 483.5H674L691 441L736.5 407.5L767 400.5L730 371.5L720 376.5L708 390L666 434.5L662 428L610 434.5L602.5 431L573.5 443.5L576.5 410.5L563.5 421L539.5 456V434.5L516.5 465Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M835.5 398L832.5 388.5H841.5L873.5 413.5L879.5 414L895 423.5V434L907.5 444L937 483.5H840.5L843.5 480L850.5 469L860 457L856.5 446.5L840.5 437.5H822.5V446.5L828 457L813.5 453L806.5 446.5V437.5L820 430.5L822.5 419.5L828 412.5L835.5 408V398Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M367.5 408L324 418.5L359 393.5H381L400 407.5L412 400.5L416 418.5L402 413L382 408H367.5Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M276 466.5L267 482.5H306L278.5 444L276 466.5Z",
  fill: "#84849F"
}), React.createElement("path", {
  d: "M390 467L385 482.5H422L411.5 469.5L369.5 442L376 452L390 467Z",
  fill: "#84849F"
}), React.createElement("path", {
  d: "M764.5 451L786.5 483H673L690 441L736.5 407.5L773.5 399L776 407.5L773.5 428.5L764.5 451Z",
  fill: "#84849F"
}));
var _ref7 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.05
}, React.createElement("path", {
  d: "M485.5 512L477 503L467 517L450 523L433 533.5L412 567L400 560L381 574H359L324 549L269 560L208 523V484H937L908 523L895 533.5V544L879.5 553.5H873.5L841.5 579H833L827.5 584L817 588L813 584L794.5 579L768 567L730.5 596H722.5L715.5 598.5L646 549L639.5 557L635.5 553.5L611.5 544L604.5 549L593.5 553.5L584 560L577.5 557L569.5 560L485.5 512Z",
  fill: "#7C7C94"
}), React.createElement("path", {
  d: "M270.691 505.045L256 484.686H308.348C312.303 484.686 316.459 481.858 308.348 498.258C296.17 522.882 270.314 538.599 256 543.5L270.691 525.403V505.045Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M314 536.5L269 560L324 549L314 536.5Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M381.955 500.422L374.015 484.5H433L419.388 500.422L400.104 509.52L357 542.5L364.94 515.206L381.955 500.422Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M422 521.5L412.5 566.5L432.5 533.5L449.5 523L467 517L476.5 503.5L451 504.5L422 521.5Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M516.5 502.5L520.5 484H545.5L570 505H602.5L628 511.5L645.5 484H674L691 526.5L736.5 560L767 567L730 596L720 591L708 577.5L666 533L662 539.5L610 533L602.5 536.5L573.5 524L576.5 557L563.5 546.5L539.5 511.5V533L516.5 502.5Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M835.5 569.5L832.5 579H841.5L873.5 554L879.5 553.5L895 544V533.5L907.5 523.5L937 484H840.5L843.5 487.5L850.5 498.5L860 510.5L856.5 521L840.5 530H822.5V521L828 510.5L813.5 514.5L806.5 521V530L820 537L822.5 548L828 555L835.5 559.5V569.5Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M367.5 559.5L324 549L359 574H381L400 560L412 567L416 549L402 554.5L382 559.5H367.5Z",
  fill: "#676777"
}), React.createElement("path", {
  d: "M276 501L267 485H306L278.5 523.5L276 501Z",
  fill: "#84849F"
}), React.createElement("path", {
  d: "M390 500.5L385 485H422L411.5 498L369.5 525.5L376 515.5L390 500.5Z",
  fill: "#84849F"
}), React.createElement("path", {
  d: "M764.5 516.5L786.5 484.5H673L690 526.5L736.5 560L773.5 568.5L776 560L773.5 539L764.5 516.5Z",
  fill: "#84849F"
}));
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M121.715 633L207.74 484H886V633H121.715Z",
  fill: "url(#paint2_linear)",
  fillOpacity: 0.06
});
var _ref9 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.25
}, React.createElement("g", {
  filter: "url(#filter2_d)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M673.978 521.442H735.623V537.827H673.978V521.442ZM675.187 522.55H676.463V536.719H675.187V522.55ZM678.612 522.55H677.336V536.719H678.612V522.55ZM679.484 522.55H680.76V536.719H679.484V522.55ZM682.909 522.55H681.633V536.719H682.909V522.55ZM683.782 522.55H685.058V536.719H683.782V522.55ZM687.207 522.55H685.931V536.719H687.207V522.55ZM688.08 522.55H689.356V536.719H688.08V522.55ZM691.505 522.55H690.229V536.719H691.505V522.55ZM692.378 522.55H693.653V536.719H692.378V522.55ZM695.802 522.55H694.527V536.719H695.802V522.55ZM696.675 522.55H697.951V536.719H696.675V522.55ZM700.1 522.55H698.824V536.719H700.1V522.55ZM700.973 522.55H702.249V536.719H700.973V522.55ZM704.398 522.55H703.122V536.719H704.398V522.55ZM705.271 522.55H706.547V536.719H705.271V522.55ZM708.695 522.55H707.42V536.719H708.695V522.55ZM709.569 522.55H710.844V536.719H709.569V522.55ZM712.993 522.55H711.717V536.719H712.993V522.55ZM713.866 522.55H715.142V536.719H713.866V522.55ZM717.291 522.55H716.015V536.719H717.291V522.55ZM718.164 522.55H719.44V536.719H718.164V522.55ZM721.589 522.55H720.313V536.719H721.589V522.55ZM722.462 522.55H723.738V536.719H722.462V522.55ZM725.886 522.55H724.61V536.719H725.886V522.55ZM726.759 522.55H728.035V536.719H726.759V522.55ZM730.184 522.55H728.908V536.719H730.184V522.55ZM731.057 522.55H732.333V536.719H731.057V522.55ZM734.482 522.55H733.206V536.719H734.482V522.55Z",
  fill: "#E2E2E3"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M738.846 521.442H800.492V537.827H738.846V521.442ZM740.055 522.55H741.331V536.719H740.055V522.55ZM743.48 522.55H742.204V536.719H743.48V522.55ZM744.353 522.55H745.629V536.719H744.353V522.55ZM747.777 522.55H746.501V536.719H747.777V522.55ZM748.65 522.55H749.926V536.719H748.65V522.55ZM752.075 522.55H750.8V536.719H752.075V522.55ZM752.948 522.55H754.224V536.719H752.948V522.55ZM756.373 522.55H755.097V536.719H756.373V522.55ZM757.246 522.55H758.522V536.719H757.246V522.55ZM760.671 522.55H759.395V536.719H760.671V522.55ZM761.543 522.55H762.819V536.719H761.543V522.55ZM764.969 522.55H763.693V536.719H764.969V522.55ZM765.841 522.55H767.117V536.719H765.841V522.55ZM769.266 522.55H767.99V536.719H769.266V522.55ZM770.139 522.55H771.415V536.719H770.139V522.55ZM773.564 522.55H772.288V536.719H773.564V522.55ZM774.437 522.55H775.713V536.719H774.437V522.55ZM777.862 522.55H776.586V536.719H777.862V522.55ZM778.735 522.55H780.01V536.719H778.735V522.55ZM782.159 522.55H780.883V536.719H782.159V522.55ZM783.032 522.55H784.308V536.719H783.032V522.55ZM786.457 522.55H785.181V536.719H786.457V522.55ZM787.33 522.55H788.606V536.719H787.33V522.55ZM790.755 522.55H789.479V536.719H790.755V522.55ZM791.628 522.55H792.904V536.719H791.628V522.55ZM795.052 522.55H793.777V536.719H795.052V522.55ZM795.925 522.55H797.201V536.719H795.925V522.55ZM799.35 522.55H798.074V536.719H799.35V522.55Z",
  fill: "#E2E2E3"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M671.829 532.858H601.454C602.886 543.603 609.62 565.091 625.091 565.091H815.265C826.01 565.091 830.092 549.19 833.531 532.858H802.641V539.843H671.829V532.858Z",
  fill: "#E2E2E3"
}), React.createElement("path", {
  d: "M608.046 553.101C611.841 559.771 617.376 565.091 625.074 565.091H815.248C821.195 565.091 825.101 560.22 827.986 553.101H608.046Z",
  fill: "#1C73FF",
  fillOpacity: 0.08
})), React.createElement("g", {
  filter: "url(#filter3_d)"
}, React.createElement("rect", {
  width: 43.1115,
  height: 7.78961,
  rx: 3.89481,
  transform: "matrix(-1 0 0 1 881.915 522.264)",
  fill: "#E2E2E3"
}), React.createElement("circle", {
  r: 2.95468,
  transform: "matrix(-1 0 0 1 749.759 365.11)",
  fill: "#C4C4C4"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M753.226 359.564L754.441 358.754L755.284 359.947L779.106 393.694H779.302L779.225 393.863L786.88 404.707H786.994L786.951 404.808L796.029 417.667H796.661L796.349 418.12L804.087 429.083H805.305L804.51 429.681L806.1 431.934L806.132 431.979L806.16 432.026L808.83 436.469H809.294L809.068 436.865L819.141 453.63L819.879 453.702L819.998 453.634L819.964 453.71L820.741 453.786L819.653 454.414L819.636 454.453L822.138 458.618L822.197 458.716L822.241 458.822L827.145 470.784H827.378L827.252 471.044L840.7 503.843C843.307 499.12 848.337 495.921 854.113 495.921V501.738H881.914V520.062H854.113V520.062H838.803V515.037L823.699 494.467H823.445L823.537 494.247L817.19 485.603H816.815L816.965 485.296L808.512 473.784H807.81L808.074 473.187L805.499 469.68L805.459 469.625L805.424 469.567L801.243 462.637L800.679 461.901L800.768 461.85L796.282 454.412L795.611 454.346L795.918 453.809L789.707 443.512L789.688 443.48L789.67 443.448L787.532 439.469H786.501L787.235 438.918L783.56 432.083H783.096L783.356 431.704L777.422 420.667H776.935L777.15 420.162L770.453 407.707H769.677L770.031 406.922L764.532 396.694H764L764.208 396.093L747.498 365.014L746.852 363.812L747.987 363.056L753.226 359.564ZM841.736 506.427V506.666V511.409H851.024V499.456C846.621 499.456 842.904 502.4 841.736 506.427ZM783.208 404.707L777.792 397.035L774.325 404.707H783.208ZM782.456 407.707H773.859L778.656 416.627L782.456 407.707ZM785.569 408.052L781.474 417.667H792.357L785.569 408.052ZM800.415 429.083L794.536 420.754L788.803 429.083H800.415ZM796.324 432.083H786.966L789.66 437.094L790.09 436.771L796.324 432.083ZM790.992 439.469H790.938L792.295 441.994L797.624 450.828L804.122 439.469H790.992ZM807.361 439.849L800.517 451.811L815.423 453.267L807.361 439.849ZM819.508 460.066L818.152 457.809L812.416 470.784H823.903L819.508 460.066ZM822.578 473.784H812.234L818.45 482.25L822.578 473.784ZM825.491 474.656L821.616 482.603H828.749L825.491 474.656ZM832.383 491.467L830.19 486.117L827.952 491.467H832.383ZM833.613 494.467H827.421L838.736 509.878V506.961L833.613 494.467ZM820.912 485.603L824.888 491.018L827.153 485.603H820.912ZM807.957 467.959L809.473 470.023L813.587 460.715L806.135 464.938L807.957 467.959ZM800.005 454.775L803.367 460.35L811.141 455.863L800.005 454.775ZM795.482 436.469H805.33L803.617 433.619L802.111 431.485L801.716 431.782L795.482 436.469ZM780.828 420.667L785.269 428.926L790.954 420.667H780.828ZM767.938 396.694L771.587 403.48L774.654 396.694H767.938ZM762.45 386.487L765.543 392.24L767.536 386.487H762.45ZM763.001 383.487H768.228L764.401 378.065L763.001 383.487ZM760.206 382.313L761.486 377.354H757.539L760.206 382.313ZM761.781 374.354H755.926L750.787 364.795L753.675 362.87L761.781 374.354ZM775.434 393.694L770.591 386.834L768.214 393.694H775.434Z",
  fill: "#E2E2E3"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M881.084 463.888L763.154 373.296L763.763 372.503L881.658 463.067L882.146 462.369V463.957V502.828H881.146V465.545L854.882 503.114L854.063 502.541L881.084 463.888Z",
  fill: "#E2E2E3"
}), React.createElement("path", {
  d: "M752 365L749.5 458L748 365",
  stroke: "#C4C4C4"
}), React.createElement("rect", {
  width: 5,
  height: 5,
  transform: "matrix(-1 0 0 1 752 457)",
  fill: "#C4C4C4"
}), React.createElement("path", {
  d: "M779.575 478.491L749.222 468.016L718.87 478.491",
  stroke: "#C4C4C4"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M748.89 463.819L748.916 461.972L749.916 461.986L749.883 464.336L749.319 464.328V464.784C748.425 464.785 747.701 465.509 747.701 466.403C747.701 467.297 748.426 468.022 749.32 468.022C750.075 468.022 750.709 467.505 750.888 466.806H751.908C751.714 468.061 750.629 469.022 749.32 469.022C747.874 469.022 746.701 467.849 746.701 466.403C746.701 465.103 747.648 464.025 748.89 463.819Z",
  fill: "white"
}), React.createElement("path", {
  d: "M748.916 461.972L748.416 461.964L748.423 461.465L748.923 461.472L748.916 461.972ZM748.89 463.819L749.39 463.826L749.384 464.244L748.971 464.313L748.89 463.819ZM749.916 461.986L749.923 461.486L750.423 461.493L750.416 461.993L749.916 461.986ZM749.883 464.336L750.383 464.343L750.375 464.843L749.875 464.836L749.883 464.336ZM749.319 464.328H748.819V463.821L749.326 463.828L749.319 464.328ZM749.319 464.784H749.819V465.284L749.319 465.284L749.319 464.784ZM750.888 466.806L750.404 466.682L750.5 466.306H750.888V466.806ZM751.908 466.806V466.306H752.491L752.402 466.883L751.908 466.806ZM749.416 461.979L749.39 463.826L748.39 463.812L748.416 461.964L749.416 461.979ZM749.909 462.486L748.909 462.472L748.923 461.472L749.923 461.486L749.909 462.486ZM749.383 464.329L749.416 461.979L750.416 461.993L750.383 464.343L749.383 464.329ZM749.326 463.828L749.89 463.836L749.875 464.836L749.312 464.828L749.326 463.828ZM749.819 464.328V464.784H748.819V464.328H749.819ZM749.319 465.284C748.702 465.285 748.201 465.785 748.201 466.403H747.201C747.201 465.233 748.149 464.285 749.319 464.284L749.319 465.284ZM748.201 466.403C748.201 467.021 748.702 467.522 749.32 467.522V468.522C748.15 468.522 747.201 467.573 747.201 466.403H748.201ZM749.32 467.522C749.841 467.522 750.28 467.165 750.404 466.682L751.373 466.93C751.138 467.845 750.309 468.522 749.32 468.522V467.522ZM750.888 466.306H751.908V467.306H750.888V466.306ZM752.402 466.883C752.171 468.378 750.88 469.522 749.32 469.522V468.522C750.379 468.522 751.257 467.745 751.414 466.73L752.402 466.883ZM749.32 469.522C747.598 469.522 746.201 468.126 746.201 466.403H747.201C747.201 467.573 748.15 468.522 749.32 468.522V469.522ZM746.201 466.403C746.201 464.855 747.329 463.57 748.808 463.326L748.971 464.313C747.967 464.479 747.201 465.352 747.201 466.403H746.201Z",
  fill: "white"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M749.57 467.824L749.762 467.745L749.954 467.825L774.752 478.225H780.046V494.61H718.4V478.225H724.234L749.57 467.824ZM726.868 478.225L749.758 468.827L772.167 478.225H726.868ZM720.885 479.332H719.609V493.501H720.885V479.332ZM721.758 479.332H723.034V493.501H721.758V479.332ZM725.183 479.332H723.907V493.501H725.183V479.332ZM726.056 479.332H727.332V493.501H726.056V479.332ZM729.481 479.332H728.205V493.501H729.481V479.332ZM730.354 479.332H731.629V493.501H730.354V479.332ZM733.778 479.332H732.502V493.501H733.778V479.332ZM734.651 479.332H735.927V493.501H734.651V479.332ZM738.076 479.332H736.8V493.501H738.076V479.332ZM738.949 479.332H740.225V493.501H738.949V479.332ZM742.374 479.332H741.098V493.501H742.374V479.332ZM743.247 479.332H744.522V493.501H743.247V479.332ZM746.672 479.332H745.396V493.501H746.672V479.332ZM747.544 479.332H748.82V493.501H747.544V479.332ZM750.969 479.332H749.693V493.501H750.969V479.332ZM751.842 479.332H753.118V493.501H751.842V479.332ZM755.267 479.332H753.991V493.501H755.267V479.332ZM756.14 479.332H757.416V493.501H756.14V479.332ZM759.564 479.332H758.289V493.501H759.564V479.332ZM760.437 479.332H761.713V493.501H760.437V479.332ZM763.862 479.332H762.586V493.501H763.862V479.332ZM764.735 479.332H766.011V493.501H764.735V479.332ZM768.16 479.332H766.884V493.501H768.16V479.332ZM769.033 479.332H770.309V493.501H769.033V479.332ZM772.458 479.332H771.182V493.501H772.458V479.332ZM773.331 479.332H774.607V493.501H773.331V479.332ZM776.756 479.332H775.48V493.501H776.756V479.332ZM777.628 479.332H778.904V493.501H777.628V479.332Z",
  fill: "#C4C4C4"
})), React.createElement("g", {
  filter: "url(#filter4_d)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M623.749 504.908H670.218V530.307H623.749V504.908ZM643.036 509.486C643.036 508.381 643.931 507.486 645.036 507.486H646.159C647.264 507.486 648.159 508.381 648.159 509.486V510.144C648.159 511.248 647.264 512.144 646.159 512.144H645.036C643.931 512.144 643.036 511.248 643.036 510.144V509.486ZM651.557 507.486C650.452 507.486 649.557 508.381 649.557 509.486V510.144C649.557 511.248 650.452 512.144 651.557 512.144H652.68C653.785 512.144 654.68 511.248 654.68 510.144V509.486C654.68 508.381 653.785 507.486 652.68 507.486H651.557ZM656.078 509.486C656.078 508.381 656.973 507.486 658.078 507.486H659.201C660.306 507.486 661.201 508.381 661.201 509.486V510.144C661.201 511.248 660.306 512.144 659.201 512.144H658.078C656.973 512.144 656.078 511.248 656.078 510.144V509.486ZM664.599 507.486C663.494 507.486 662.599 508.381 662.599 509.486V510.144C662.599 511.248 663.494 512.144 664.599 512.144H665.722C666.827 512.144 667.722 511.248 667.722 510.144V509.486C667.722 508.381 666.827 507.486 665.722 507.486H664.599Z",
  fill: "#E2E2E3"
}), React.createElement("path", {
  d: "M659.105 486.468C659.105 485.985 659.496 485.594 659.978 485.594C660.461 485.594 660.852 485.985 660.852 486.468V505.507H659.105V486.468Z",
  fill: "#E2E2E3"
}), React.createElement("rect", {
  x: 630.809,
  y: 493.496,
  width: 6.63746,
  height: 12.1105,
  fill: "#E2E2E3"
}), React.createElement("rect", {
  x: 630.809,
  y: 493.496,
  width: 6.63746,
  height: 3.85957,
  fill: "#7C7C94"
})));
var _ref10 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.25,
  filter: "url(#filter5_d)"
}, React.createElement("path", {
  d: "M289.89 645.468H404.271C406.764 645.468 408.786 647.49 408.786 649.983C408.786 652.477 406.764 654.498 404.271 654.498H289.89V645.468Z",
  fill: "#353541"
}), React.createElement("path", {
  d: "M381.339 642.394H399.858V648.736H381.339V642.394Z",
  fill: "#303641"
}), React.createElement("rect", {
  x: 264.46,
  y: 640.744,
  width: 33.1585,
  height: 13.4985,
  fill: "#091F42"
}), React.createElement("circle", {
  cx: 280.073,
  cy: 658.282,
  r: 11.4673,
  fill: "#979797"
}), React.createElement("circle", {
  cx: 280.073,
  cy: 658.282,
  r: 7.05154,
  fill: "#E0E0E0"
}), React.createElement("circle", {
  cx: 280.073,
  cy: 658.282,
  r: 3.81596,
  fill: "#C4C4C4"
}), React.createElement("path", {
  d: "M291.599 612.025L286.65 624.947V641.168L290.225 643.918H309.47V612.025H291.599Z",
  stroke: "#E0E0E0"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M257 637.167V650.545V650.901C257 654.214 259.686 656.901 263 656.901H266.671C266.671 650.545 269.987 644.19 280.764 644.19C291.54 644.19 293.566 653.769 293.751 659.388H297.067V646.953H312.817V644.19H346.528V582.847H336.58C326.854 582.847 320.37 586.347 318.343 588.097L297.067 610.203H294.469C292.03 610.203 289.833 611.68 288.913 613.939L284.356 625.124L261.421 631.379C258.811 632.091 257 634.462 257 637.167ZM292.974 614.499L289.125 624.947H307.271V614.499H292.974ZM327.711 608.445L333.696 602.145H343.146V608.445H327.711Z",
  fill: "#C4C4C4"
}), React.createElement("rect", {
  x: 301.764,
  y: 648.887,
  width: 40.6993,
  height: 12.2963,
  fill: "#979797"
}), React.createElement("rect", {
  x: 359.515,
  y: 639.769,
  width: 288.108,
  height: 4.69745,
  fill: "#E0E0E0"
}), React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M338.06 648.335H322.492V661.875H338.06V648.335ZM339.379 661.875H344.508C348.167 656.127 346.032 650.453 344.508 648.335H339.379V661.875ZM307.481 648.335H321.173V661.875H307.481V648.335ZM306.162 648.335H299.477C297.789 653.198 298.774 659.388 299.477 661.875H306.162V648.335Z",
  fill: "#C4C4C4"
}), React.createElement("path", {
  d: "M287.396 625.124V639.493L289.606 643.914H308.672V613.242H292.093L287.396 625.124Z",
  stroke: "#FCFCFC"
}), React.createElement("rect", {
  x: 327.118,
  y: 613.319,
  width: 3.69745,
  height: 8.94755,
  rx: 1.84873,
  stroke: "#FCFCFC"
}), React.createElement("rect", {
  x: 323.535,
  y: 631.296,
  width: 15.3083,
  height: 8.94755,
  rx: 2.5,
  stroke: "#FCFCFC"
}), React.createElement("path", {
  d: "M540.362 648.28C537.683 649.87 535.024 652.794 534.288 655.051H620.156C619.512 653.697 617.506 650.446 614.634 648.28C611.763 646.113 608.652 645.571 607.455 645.571H551.682C548.553 645.662 544.926 645.571 540.362 648.28Z",
  fill: "#353541"
}), React.createElement("rect", {
  x: 359.516,
  y: 582,
  width: 288.108,
  height: 59.9794,
  fill: "#C4C4C4"
}), React.createElement("rect", {
  x: 359.516,
  y: 582,
  width: 288.108,
  height: 2.5047,
  fill: "#E0E0E0"
}), React.createElement("line", {
  x1: 370.036,
  y1: 641.979,
  x2: 370.036,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 380.904,
  y1: 641.979,
  x2: 380.904,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 392.142,
  y1: 641.979,
  x2: 392.142,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 403.009,
  y1: 641.979,
  x2: 403.009,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 414.248,
  y1: 641.979,
  x2: 414.248,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 425.115,
  y1: 641.979,
  x2: 425.115,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 436.353,
  y1: 641.979,
  x2: 436.353,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 447.221,
  y1: 641.979,
  x2: 447.221,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 458.459,
  y1: 641.979,
  x2: 458.459,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 469.326,
  y1: 641.979,
  x2: 469.326,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 480.564,
  y1: 641.979,
  x2: 480.564,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 491.432,
  y1: 641.979,
  x2: 491.432,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 502.67,
  y1: 641.979,
  x2: 502.67,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 513.538,
  y1: 641.979,
  x2: 513.538,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 524.776,
  y1: 641.979,
  x2: 524.776,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 535.643,
  y1: 641.979,
  x2: 535.643,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 546.881,
  y1: 641.979,
  x2: 546.881,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 557.749,
  y1: 641.979,
  x2: 557.749,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 568.987,
  y1: 641.979,
  x2: 568.987,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 579.854,
  y1: 641.979,
  x2: 579.854,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 591.093,
  y1: 641.979,
  x2: 591.093,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 601.96,
  y1: 641.979,
  x2: 601.96,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 613.198,
  y1: 641.979,
  x2: 613.198,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 624.066,
  y1: 641.979,
  x2: 624.066,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("line", {
  x1: 635.119,
  y1: 641.979,
  x2: 635.119,
  y2: 584.505,
  stroke: "#F7F7F7",
  strokeWidth: 0.5
}), React.createElement("rect", {
  x: 359.515,
  y: 583.252,
  width: 2.74386,
  height: 58.7271,
  fill: "#E0E0E0"
}), React.createElement("rect", {
  x: 644.678,
  y: 583.252,
  width: 2.74386,
  height: 58.7271,
  fill: "#E0E0E0"
}), React.createElement("path", {
  d: "M534.288 655.051C535.024 652.794 537.683 649.87 540.362 648.28C544.926 645.571 548.553 645.662 551.682 645.571H607.455C608.652 645.571 611.763 646.113 614.634 648.28C617.506 650.446 619.512 653.697 620.156 655.051",
  stroke: "#878789",
  strokeWidth: 3
}), React.createElement("path", {
  d: "M366.628 648.517C364.77 649.921 362.927 652.504 362.416 654.498H421.963C421.516 653.302 420.125 650.431 418.134 648.517C416.142 646.603 413.985 646.124 413.155 646.124H374.478C372.308 646.204 369.793 646.124 366.628 648.517Z",
  fill: "#353541"
}), React.createElement("path", {
  d: "M362.416 654.498C362.927 652.504 364.77 649.921 366.628 648.517C369.793 646.124 372.308 646.204 374.478 646.124H413.155C413.985 646.124 416.142 646.603 418.134 648.517C420.125 650.431 421.516 653.302 421.963 654.498",
  stroke: "#878789",
  strokeWidth: 3
}), React.createElement("circle", {
  cx: 552.525,
  cy: 658.282,
  r: 11.4673,
  fill: "#979797"
}), React.createElement("circle", {
  cx: 552.525,
  cy: 658.282,
  r: 7.05154,
  fill: "#E0E0E0"
}), React.createElement("circle", {
  cx: 552.525,
  cy: 658.059,
  r: 3.81596,
  fill: "#C4C4C4"
}), React.createElement("circle", {
  cx: 577.394,
  cy: 658.282,
  r: 11.4673,
  fill: "#979797"
}), React.createElement("circle", {
  cx: 577.394,
  cy: 658.282,
  r: 7.05154,
  fill: "#E0E0E0"
}), React.createElement("circle", {
  cx: 577.394,
  cy: 658.059,
  r: 3.81596,
  fill: "#C4C4C4"
}), React.createElement("circle", {
  cx: 602.263,
  cy: 658.282,
  r: 11.4673,
  fill: "#979797"
}), React.createElement("circle", {
  cx: 602.262,
  cy: 658.282,
  r: 7.05154,
  fill: "#E0E0E0"
}), React.createElement("circle", {
  cx: 602.263,
  cy: 658.059,
  r: 3.81596,
  fill: "#C4C4C4"
}), React.createElement("circle", {
  cx: 377.337,
  cy: 658.282,
  r: 11.4673,
  fill: "#979797"
}), React.createElement("circle", {
  cx: 377.338,
  cy: 658.282,
  r: 7.05154,
  fill: "#E0E0E0"
}), React.createElement("circle", {
  cx: 377.337,
  cy: 658.059,
  r: 3.81596,
  fill: "#C4C4C4"
}), React.createElement("circle", {
  cx: 404.97,
  cy: 658.282,
  r: 11.4673,
  fill: "#979797"
}), React.createElement("circle", {
  cx: 404.97,
  cy: 658.282,
  r: 7.05154,
  fill: "#E0E0E0"
}), React.createElement("circle", {
  cx: 404.97,
  cy: 658.059,
  r: 3.81596,
  fill: "#C4C4C4"
}), React.createElement("path", {
  d: "M259.211 650.131H257.138V644.328H261.007L259.211 650.131Z",
  fill: "#FFE3BD"
}), React.createElement("path", {
  d: "M267.017 653.162H257C257 655.87 258.98 656.777 259.97 656.892H266.602C266.547 656.008 266.855 654.037 267.017 653.162Z",
  fill: "#C4C4C4"
}), React.createElement("rect", {
  x: 346.528,
  y: 585.256,
  width: 2.80997,
  height: 56.3694,
  fill: "#42424A"
}), React.createElement("rect", {
  x: 347.91,
  y: 582.847,
  width: 5.52641,
  height: 61.071,
  rx: 1,
  fill: "#C4C4C4"
}), React.createElement("g", {
  filter: "url(#filter6_f)"
}, React.createElement("path", {
  d: "M166 665L268 648L166 629V665Z",
  fill: "url(#paint3_linear)",
  className: "blink_me"
})));
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M840.949 532L831 564.645L859.296 586.15C861.496 587.822 862.906 590.33 863.191 593.079L871.176 670H886V532H840.949Z",
  fill: "#0D182B"
});
var _ref12 = /*#__PURE__*/React.createElement("defs", null, React.createElement("filter", {
  id: "filter0_d",
  x: 0,
  y: -202,
  width: 1377.02,
  height: 1471.47,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "filter1_f",
  x: 227,
  y: 335.5,
  width: 731,
  height: 162,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 12.5,
  result: "effect1_foregroundBlur"
})), React.createElement("filter", {
  id: "filter2_d",
  x: 597.454,
  y: 521.442,
  width: 240.077,
  height: 51.649,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "filter3_d",
  x: 693.4,
  y: 337.754,
  width: 213.745,
  height: 221.3,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 12.5
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "filter4_d",
  x: 619.749,
  y: 485.594,
  width: 54.4691,
  height: 52.7124,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "filter5_d",
  x: 162,
  y: 582,
  width: 489.623,
  height: 95.7497,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 4
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), React.createElement("filter", {
  id: "filter6_f",
  x: 156,
  y: 619,
  width: 122,
  height: 56,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  result: "effect1_foregroundBlur"
})), React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 868.148,
  y1: 311.724,
  x2: 1063.45,
  y2: -286.007,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#0D182B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#030D1D",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 920.324,
  y1: 739.524,
  x2: -377.676,
  y2: 907.524,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.151042,
  stopColor: "#0D182B"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#373746"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 555,
  y1: 764,
  x2: 1135,
  y2: 818,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.28001,
  stopColor: "#1C73FF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#4C87E6",
  stopOpacity: 0
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 250.857,
  y1: 647,
  x2: 150.579,
  y2: 647.89,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0.437322,
  stopColor: "#FFEBA6"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FFEBA6",
  stopOpacity: 0
})));
const SvgHomePageGraphic = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    viewBox: "0 0 886 922",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgHomePageGraphic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/home-page-graphic.b8add9b0.svg";
export { ForwardRef as ReactComponent };